import styled from 'styled-components';
import { flexMixin, textMixin } from '@styles/mixins';

export const Wrapper = styled.div`
    ${flexMixin('column', 'center', 'center')};
    gap: 20px;
    padding-top: 10px;
`;

export const Title = styled.div`
    ${textMixin({
        fontSize: '27px',
        fontWeight: 600,
    })};
    width: 100%;
    padding: 10px 0;
`;
